图表类型<template>
<!-- 动态图表 -->
    <div class="pd20">
        <div class="main">
            <!-- list 规则 rules -->
            <div class="list-box ">
                <el-table :data="list" show-overflow-tooltip border style="width: 100%">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column type="index" width="100" label="序号"></el-table-column>
                    <el-table-column prop="name" label="图表名称" ></el-table-column>
                    <el-table-column  label="图表类型">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.chart_type==0" size="mini">柱状图</el-tag>
                            <el-tag v-if="scope.row.chart_type==1" size="mini">折线图</el-tag>
                            <el-tag v-if="scope.row.chart_type==2" size="mini">仪表盘</el-tag>
                            <el-tag v-if="scope.row.chart_type==3" size="mini">雷达图</el-tag>
                            <el-tag v-if="scope.row.chart_type==4" size="mini">条形图</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="图表数据" >
                        <template slot-scope="scope">
                            <!-- 把字符串转换为数组 -->
                            <span v-for="(item,index) in formula_list" :key="index" >
                                <span v-for="(ite,i) in scope.row.formula_id.split(',')" :key="i">
                                    <el-tag class="tag"  v-if="ite==item.id"  size="mini">
                                        {{item.name}}
                                    </el-tag>
                                </span>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column width="150"  label="操作">
                        <template slot-scope="scope">
                            <el-button type="primary" size="mini" icon="el-icon-edit" @click="updateGraph(scope.$index, scope.row,$event)"  circle></el-button>
                            <el-button type="danger" size="mini" icon="el-icon-delete" @click="graphDelete(scope.$index, scope.row)"  circle></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 添加按钮 -->
            <el-button type="primary" class="addBtn" size="mini" icon="el-icon-circle-plus"  @click="addGraph" circle></el-button>
            <!-- 分页 -->
            <el-pagination class="pages"
                :page-sizes="[25, 50, 75, 100]"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-size="pages.size"
                :current-page="pages.page"
                background
                layout="sizes,prev, pager, next"
                :total="pages.count">
            </el-pagination>
            <!-- -->
            <!-- <div class="pages-box"></div>  -->
        </div>
        <!-- 添加or修改 -->
        <el-dialog   :visible.sync="dialogGraph" width="50%">
            <el-form class="form-box" :model="form">
                <el-form-item label="图表名称" :label-width="formLabelWidth">
                    <el-input v-model="form.name" placeholder="请输入图表名称"></el-input>
                </el-form-item>
                <!--  -->
                <el-form-item label="图表类型" :label-width="formLabelWidth">
                    <el-select v-model="form.chart_type" placeholder="请选择图表类型" @change="chartTypeChange">
                        <!-- 0：柱状图、1：折线图、2：仪表盘、3：雷达图 -->
                        <el-option label="柱状图" value="0"></el-option>
                        <el-option label="折线图" value="1"></el-option>
                        <el-option label="仪表盘" value="2"></el-option>
                        <el-option label="雷达图" value="3"></el-option>
                        <el-option label="条形图" value="4"></el-option>
                    </el-select>
                </el-form-item>
                <!--  -->
                <el-form-item label="数据" :label-width="formLabelWidth">
                    <!-- 直接在data的form对象里声明数组成了一个boolean数组，只有单独声明了checkList数组 -->
                    <!-- 判断如果图表类型是仪表盘就只能选择一个 -->
                    <el-checkbox-group v-model="checkList" @change="checkChange" :max="form.chart_type==2?1:formula_list.length">
                        <el-checkbox v-for="(item,index) in formula_list" :key="index"  :label="item.id.toString()" :class="['checkBox',(form.chart_type==2 && checkList.indexOf(item.id.toString()) && checkList.length>0)?'graph-on':'']" :disabled="checkList.length>0 && form.chart_type ==2 && checkList.indexOf(item.id.toString())&& checkList.length>0" >{{item.name+'（'+item.alias_name+'）'}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                 <!--  -->
                <el-form-item label="预览" :label-width="formLabelWidth">
                    <public-chart v-if="isShowChart" class="chart" :chartData='chartData' :type="form.chart_type"></public-chart>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogGraph = false">取 消</el-button>
                <el-button type="primary" @click="submitHandle">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 动态图表 -->
    </div>
</template>

<script>
import { chartList,chartAdd,chartDel} from "@/api/measurement";
import { deepCopy} from "@u/tools";
import publicChart from "@c/public-chart";

export default {
    data() {
        return{
            list: [],
            pages: {},
            dialogGraph:false,
            formLabelWidth: '80px',
            form:{
                name:'',
                chart_type:''
            },
            checkList:[],
            //
            formula_list:[],
            chartData:[],
            isShowChart:false,
            //仪表盘
            dashboard:[] 
            
        }
    },
    components:{
        publicChart
    },
    methods:{
        // 调整每页显示条数
        handleSizeChange(val) {
            this.pages.size = val;
            this.pullData();
        },
        // 触发分页
        handleCurrentChange(val) {
            this.pages.page = val;
            this.pullData();
        },
        graphDelete(index,row){
            this.$confirm('是否确认删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if(row.id){
                    chartDel({
                        id:row.id
                    }).then((data)=>{
                        this.$notify({
                            title: '成功',
                            message: '添加成功',
                            type: 'success'
                        });
                    });
                }
                this.list.splice(index, 1);
            }).catch();

        },
        submitHandle(){
            if(!this.form['id']){
                this.form['eid'] = this.$route.query.id;
            }

            this.form['formula_id'] = this.checkList.join(',');
            chartAdd(this.form).then((data)=>{
                if(data.error >0){
                    this.$message(data.msg);
                    return
                }

                this.$notify({
                    title: '成功',
                    message: '添加成功',
                    type: 'success'
                });

                this.pullData();
            });
            this.dialogGraph = false;
        },
        // 改变图表类型时，清空选项数组
        chartTypeChange(val) {
            this.isShowChart = false;
            // val===2，仪表盘
            if(val==='2'){
                // 保存一下选项值
                this.dashboard = this.checkList.concat();
                // 删除数组中的值，保留第一个
                this.chartData.splice(1,this.chartData.length);
            }
            if(this.dashboard.length>0 && val!=='2'){
                // 获得之前保存数组赋给图表类型数组
                this.checkList = this.dashboard.concat();
                // 清空数组
                this.dashboard.splice(0,this.dashboard.length);
                // 给图表重新传值
                let chartArr = [];
                // 动态图表组件所需数据进行组合
                this.checkList.forEach((l) => {
                    this.formula_list.forEach((f) => {
                        if(f.id == l){
                            chartArr.push({
                                score:this.form.chart_type==2?f.total_score/10:f.total_score,
                                item:f.name
                            });
                        }
                    });
                });

                this.chartData = chartArr.concat();
            }

            if(this.checkList.length==0){
                return
            }
            this.$nextTick(()=>{
                this.isShowChart = true;
            });
        },
        checkChange(val){
            this.isShowChart = false;
            this.checkList = val;

            if(!val || val.length==0){
                return
            }

            let chartArr = [];
            // 动态图表组件所需数据进行组合
            this.checkList.forEach((l) => {
                this.formula_list.forEach((f) => {
                    if(f.id == l){
                        chartArr.push({
                            score:this.form.chart_type==2?f.total_score/10:f.total_score,
                            item:f.name
                        });
                    }
                });
            });
            this.chartData = chartArr.concat();
            this.$nextTick(()=>{
                this.isShowChart = true;
            });
        },
        // 添加动态图表
        addGraph(){
             // 清空
                this.form.name = '';
                this.form.chart_type = '';
                // 删除数组中所有元素
                this.checkList.splice(0,this.checkList.length);
            this.dialogGraph = true;
        },
        // 修改动态图表
        updateGraph(index,row){
            this.checkList = row.formula_id.split(',');
            this.form = deepCopy(row);
            let chartArr = [];

            // 动态图表组件所需数据进行组合
            this.checkList.forEach((l) => {
                this.formula_list.forEach((f) => {
                    if(f.id == l){
                        chartArr.push({
                            score:this.form.chart_type==2?f.total_score/10:f.total_score,
                            item:f.name
                        });

                    }
                });
            });
            this.chartData = chartArr.concat();
            this.dialogGraph = true;
        },
        pullData(){
            this.$showLoading();
            chartList({
                eid:this.$route.query.id,
                page:this.pages?this.pages.page:null,  //页码，默认1
                size:this.pages?this.pages.size:null   //每页数量，默认25
            }).then((data)=>{
                this.pages = data.pager;
                this.list = data.list;
                // 获得公式
                this.formula_list = data.formula;
                this.$hideLoading();

            }).catch(()=>{
                this.$hideLoading();
            });

        }
    },
    created(){
        this.pullData();
    },
    watch:{
        dialogGraph(newVal,oldVal){
            if(this.checkList.length>0 && this.form.chart_type){
                this.isShowChart = newVal;
            }
            
        }
    }
}
</script>

<style lang="scss" scoped>
.main{
  position: relative;
}
.addBtn{
  position: absolute;
  left: 0;
  bottom: 0;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.pages-box{
    height: 32px;
    margin-top: 30px;
}
.graph-on{
    opacity: .7;
}
.preview{
    width: 300px;
    border-radius: 5px;
}
.tag{
    margin-right: 10px;
}
.checkBox{
    color:#fff;
}
</style>
<style lang="scss">
.form-box input{
    background-color: #fff !important;
    color: #333 !important;
    min-width: 300px;
}
</style>
